<ng-container
  *ngIf="{
    activeFilters: activeFilters$ | async,
    initialFilterCount: initialFilterCount$ | async,
    isResetFiltersAvailable: isResetFiltersAvailable$ | async,
    showMoreFilterAvailable: showMoreFilterAvailable$ | async,
    orderFilters: orderFilters$ | async
  } as componentData"
>
  <atx-filter-select-item
    *ngFor="
      let orderFilter of componentData.orderFilters;
      let index = index;
      trackBy: trackByValue
    "
    [filterItem]="orderFilter"
    [activeValues]="getActiveValues(orderFilter, componentData.activeFilters)"
    (toggleFilter)="onToggleFilter(orderFilter, $event)"
    [selectedValuesAsLabel]="orderFilter.isSingle ?? false"
    dropdownButtonClass="btn-light"
    class="order-filters-item mr-2 mb-2"
    [ngClass]="{
      'd-none': allFiltersShown
        ? false
        : index >= (componentData.initialFilterCount ?? -1)
    }"
  ></atx-filter-select-item>

  <atx-input-date-range
    class="mr-2 mb-2 align-self-center"
    [atxTooltip]="dateRangePlaceholder"
    *ngIf="componentData.orderFilters?.length"
    [range]="periodValue$ | async"
    [formControl]="rangeControl"
    [minDate]="minDate$ | async"
    [maxDate]="maxDate$ | async"
    [allowClear]="false"
    [allowWriteValueReset]="true"
    [placeholder]="dateRangePlaceholder"
  ></atx-input-date-range>

  <button
    *ngIf="componentData.showMoreFilterAvailable"
    (click)="allFiltersShown = !allFiltersShown"
    class="mr-2 mb-2 nostyle-button"
  >
    <ng-container *ngIf="allFiltersShown; else showMoreLabel">
      <fa-icon [icon]="['fas', 'minus']" size="xs"></fa-icon
      ><span
        class="ml-1"
        i18n="orderBook|More filters less button text@@lessFiltersBtnText"
        >Less Filters</span
      >
    </ng-container>
  </button>
  <button
    (click)="resetFilters()"
    *ngIf="componentData.isResetFiltersAvailable"
    class="mr-2 mb-2 btn btn-light text-truncate align-self-baseline"
  >
    <fa-icon [icon]="['fas', 'trash-can']" size="xs"></fa-icon
    ><span
      class="ml-1"
      i18n="orderBook|Clear filters button text@@clearFiltersBtnText"
      >Clear filters</span
    >
  </button>
</ng-container>

<ng-template #showMoreLabel>
  <fa-icon [icon]="['fas', 'plus']" size="xs"></fa-icon
  ><span
    class="ml-1"
    i18n="orderBook|More filters button text@@moreFiltersBtnText"
    >More Filters</span
  >
</ng-template>
